import { TravelAlertBuilder } from '@/data/builders'
import { makeDateAdapterFactory } from '@/main/adapters'

export const makeTravelAlertBuilder = (): TravelAlertBuilder => {
  return new TravelAlertBuilder(makeDateAdapterFactory())
}
